import React from 'react';
import { useSelector } from 'react-redux';
import type { MembershipBannerProps } from '@noths/polaris-client-ribbons-design-system';
import { MembershipBanner } from '@noths/polaris-client-ribbons-design-system';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { MembershipBannerLocation } from 'src/tracking/events/membershipBannerEvents';
import { trackImpression, trackLinkClick } from 'src/tracking/events/membershipBannerEvents';
import * as styles from './MembershipBannerSection.styles';

interface MembershipBannerSectionProps extends Partial<MembershipBannerProps> {
  trackingLocation: MembershipBannerLocation;
}

export const MembershipBannerSection = ({ trackingLocation }: MembershipBannerSectionProps) => {
  const content = useSelector((state: ReduxApplicationState) => state.content.membershipBanner);

  if (!content) {
    return null;
  }

  const trackingArgs = {
    contentType: `membership banner|${content.trackingTitle}`,
    label: content.trackingTitle,
    location: trackingLocation,
  };

  return (
    <div css={styles.wrapper}>
      <MembershipBanner
        backgroundImageUrl={content.backgroundImageUrl}
        buttonHref={content.buttonHref}
        buttonText={content.buttonText}
        copy={content.copy}
        heading={content.heading}
        onButtonClick={(e) => trackLinkClick(e, trackingArgs)}
        onVisible={() => trackImpression(trackingArgs)}
      />
    </div>
  );
};
